var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockIconAcitve(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "32D914AE-6C8D-465B-891F-26AA9AD1F78C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-home",
    transform: "translate(-150, -488)",
    fill: "#CEFAB7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy-5",
    transform: "translate(118, 453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stock-icon",
    transform: "translate(32, 35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M16,2.13333333 C8.34165147,2.13333333 2.13333333,8.34165147 2.13333333,16 C2.13333333,23.6583485 8.34165147,29.8666667 16,29.8666667 C23.6583485,29.8666667 29.8666667,23.6583485 29.8666667,16 C29.8666667,8.34165147 23.6583485,2.13333333 16,2.13333333 Z M16,5.33333333 C21.8910373,5.33333333 26.6666667,10.1089627 26.6666667,16 C26.6666667,19.4895007 24.991054,22.5876411 22.4005434,24.5337063 C20.6168767,25.8733207 18.4010863,26.6666667 16,26.6666667 C13.5989137,26.6666667 11.3831233,25.8733207 9.60045953,24.5344597 C7.00894603,22.5876411 5.33333333,19.4895007 5.33333333,16 C5.33333333,10.1089627 10.1089627,5.33333333 16,5.33333333 Z M14.9338386,7.53262368 C13.7794328,7.67650615 12.6966275,8.05097511 11.7329658,8.60848736 L11.7329658,23.3915126 C12.6966275,23.9490249 13.7794328,24.3234938 14.9338386,24.4673763 L14.9338386,7.53262368 Z M17.067164,7.53274871 L17.067164,24.4672513 C18.2211942,24.323277 19.3036515,23.9488635 20.2670342,23.3915126 L20.2670342,8.60848736 C19.3036515,8.05113652 18.2211942,7.676723 17.067164,7.53274871 Z M9.59945813,10.3561886 C8.2720722,11.8603965 7.46666667,13.836142 7.46666667,16 C7.46666667,18.1639804 8.27216331,20.139827 9.59968336,21.6440666 L9.59945813,10.3561886 Z M22.4005419,10.3561886 L22.4003166,21.6440666 C23.7278367,20.139827 24.5333333,18.1639804 24.5333333,16 C24.5333333,13.836142 23.7279278,11.8603965 22.4005419,10.3561886 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockIconAcitve);
export default __webpack_public_path__ + "static/media/stock-icon-acitve.5e58fb899358f66d7ea8a6d16a44b268.svg";
export { ForwardRef as ReactComponent };